import React from 'react';
import './addcta.css'
import pic24 from '../../assets/pic24.png'

const AddCTA = (props) => {
    return ( 
        <button className='cta-event' type="button"           onClick={props.onClick}   >
                <img src={pic24} alt='icon'></img>
                <h2 className='cta-event-text'>{props.title}</h2>
        </button>
     );
}
 
export default AddCTA;